// extracted by mini-css-extract-plugin
module.exports = {"page":"index_page__9DSr6","nav":"index_nav__mmBmv","main":"index_main__iXFtb","foot":"index_foot__GAo_0"};